import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { SettingsService } from './settings.service'
import { CountriesService } from 'src/app/builder-services/countries/countries.service'
import { VendorService } from 'src/app/multivendor/vendor.service'

// Interfaces
interface DropDownList {
  code: string
  symbol: string
  name: string
}

interface Settings {
  currency?: string
  countryOptions?: string
  estimatedDeliveryTime?: string
  estimatedDeliveryUnit?: string
  hideOutStockProduct?: boolean
  useVariantImageAsMain?: boolean
  selectedCountries?: string[]
  countryNumber?: string
  enableGoogleMaps?: boolean
  showArea?: boolean
  showInstagram?: boolean
  showFacebook?: boolean
  showPhoneNumber?: boolean
  showCountry?: boolean
  meta_pixel_id?: string
  meta_client_token?: string
  facebook_displayName?: string
  allowUpload: boolean
  // freeShipping?: boolean
  // ✅ Email on Order fields
  enableOrderEmail?: boolean
  emailTemplate?: string
  emailSubject?: string
  emailSignature?: string
  enableOrderBooking?: boolean
  // order booking data
  orderBooking?: {
    day: string;
    value: number;
    from: string;
    to: string;
    state: string;
  }[];
  shippingOption?: string
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  // State
  settings: Settings = {
    allowUpload: false
  }
  settingsProgress = false
  saveState = false
  countries: any[] = []
  currency: string = ''
  countryOptions: string = 'all'
  estimatedDeliveryTime: string = '20'
  estimatedDeliveryUnit: string = 'minutes'
  useVariantImageAsMain: boolean = false
  hideOutStockProduct: boolean = false
  enableGoogleMaps: boolean = false
  showCountry: boolean = true
  showArea: boolean = true
  showInstagram: boolean = false
  showFacebook: boolean = false
  showPhoneNumber: boolean = false
  // freeShipping: boolean = false
  selectedCountries: string[] = []
  countryNumber: string = ''
  settingsForm: FormGroup
  allowUpload: boolean = false
  scheduleData: any[] = []; //will hold emitted schedule array
  shippingOption: string = 'show';

  CurrencyList: DropDownList[] = [
    {
      symbol: 'د.إ',
      code: 'AED',
      name: 'United Arab Emirates Dirham'
    },
    {
      symbol: '؋',
      code: 'AFN',
      name: 'Afghan Afghani'
    },
    {
      symbol: 'ل.ل',
      code: 'LBP',
      name: 'Lebanese Pound'
    },
    {
      symbol: 'د.ت',
      code: 'TND',
      name: 'Tunisian Dinar'
    },
    {
      symbol: 'ل.س',
      code: 'ل.س',
      name: 'Syrian Pound'
    },
    {
      symbol: 'د.أ',
      code: 'JOD',
      name: 'Jordanian Dinar'
    },
    {
      symbol: '$',
      code: 'ARS',
      name: 'Argentine Peso'
    },
    {
      symbol: '$',
      code: 'AUD',
      name: 'Australian Dollar'
    },
    {
      symbol: 'B$',
      code: 'BSD',
      name: 'Bahamian Dollar'
    },
    {
      symbol: 'BZ$',
      code: 'BZD',
      name: 'Belize Dollar'
    },
    {
      symbol: 'R$',
      code: 'BRL',
      name: 'Brazilian Real'
    },
    {
      symbol: '$',
      code: 'CLP',
      name: 'Chilean Peso'
    },
    {
      symbol: '$',
      code: 'COP',
      name: 'Colombian Peso'
    },
    {
      symbol: '$',
      code: 'MXN',
      name: 'Mexican Peso'
    },
    {
      symbol: '$',
      code: 'TTD',
      name: 'Trinidad and Tobago Dollar'
    },
    {
      symbol: '₣',
      code: 'CHF',
      name: 'Swiss Franc'
    },
    {
      symbol: '£',
      code: 'GBP',
      name: 'British Pound Sterling'
    },
    {
      symbol: 'KM',
      code: 'BAM',
      name: 'Bosnia and Herzegovina Convertible Mark'
    },
    {
      symbol: '₸',
      code: 'KZT',
      name: 'Kazakhstani Tenge'
    },
    {
      symbol: 'сом',
      code: 'KGS',
      name: 'Kyrgyzstani Som'
    },
    {
      symbol: 'د.ع',
      code: 'IQD',
      name: 'Iraqi Dinar'
    },
    {
      symbol: 'ر.ي',
      code: 'YER',
      name: 'Yemeni Rial'
    },
    {
      symbol: 'ر.ق',
      code: 'QAR',
      name: 'Qatari Riyal'
    },
    {
      symbol: 'د.ب',
      code: 'BHD',
      name: 'Bahrain Dinar'
    },
    {
      symbol: 'сўм',
      code: 'UZS',
      name: 'Uzbekistani Som'
    },
    {
      symbol: 'ر.س',
      code: 'SDG',
      name: 'Sudanese Pound'
    },
    {
      symbol: 'Sh',
      code: 'KES',
      name: 'Kenyan Shilling'
    },
    {
      symbol: 'USh',
      code: 'UGX',
      name: 'Ugandan Shilling'
    },
    {
      symbol: 'د.ج',
      code: 'DZD',
      name: 'Algerian Dinar'
    },
    {
      symbol: 'Fr',
      code: 'RWF',
      name: 'Rwandan Franc'
    },
    {
      symbol: '₵',
      code: 'GHS',
      name: 'Ghanaian Cedi'
    },
    {
      symbol: 'CFA',
      code: 'XOF',
      name: 'West African CFA Franc'
    },
    {
      symbol: 'CFA',
      code: 'XAF',
      name: 'Central African CFA Franc'
    },
    {
      symbol: '$',
      code: 'NZD',
      name: 'New Zealand Dollar'
    },
    {
      symbol: '$',
      code: 'FJD',
      name: 'Fijian Dollar'
    },
    {
      symbol: 'K',
      code: 'PGK',
      name: 'Papua New Guinean Kina'
    },
    {
      symbol: '₼',
      code: 'AZN',
      name: 'Azerbaijani Manat'
    },
    {
      symbol: 'лв',
      code: 'BGN',
      name: 'Bulgarian Lev'
    },
    {
      symbol: '৳',
      code: 'BDT',
      name: 'Bangladeshi Taka'
    },
    {
      symbol: 'Br',
      code: 'BYN',
      name: 'Belarusian Ruble'
    },
    {
      symbol: '៛',
      code: 'KHR',
      name: 'Cambodian Riel'
    },
    {
      symbol: '$',
      code: 'CAD',
      name: 'Canadian Dollar'
    },
    {
      symbol: '₡',
      code: 'CRC',
      name: 'Costa Rican Colón'
    },
    {
      symbol: 'kn',
      code: 'HRK',
      name: 'Croatian Kuna'
    },
    {
      symbol: 'Kč',
      code: 'CZK',
      name: 'Czech Koruna'
    },
    {
      symbol: 'kr',
      code: 'DKK',
      name: 'Danish Krone'
    },
    {
      symbol: 'RD$',
      code: 'DOP',
      name: 'Dominican Peso'
    },
    {
      symbol: 'EGP',
      code: 'EGP',
      name: 'Egyptian Pound'
    },
    {
      symbol: '¢',
      code: 'GHS',
      name: 'Ghanaian Cedi'
    },
    {
      symbol: 'Q',
      code: 'GTQ',
      name: 'Guatemalan Quetzal'
    },
    {
      symbol: 'L',
      code: 'HNL',
      name: 'Honduran Lempira'
    },
    {
      symbol: 'Ft',
      code: 'HUF',
      name: 'Hungarian Forint'
    },
    {
      symbol: 'Rp',
      code: 'IDR',
      name: 'Indonesian Rupiah'
    },
    {
      symbol: '₪',
      code: 'ILS',
      name: 'Israeli New Shekel'
    },
    {
      symbol: '₹',
      code: 'INR',
      name: 'Indian Rupee'
    },
    {
      symbol: '¥',
      code: 'JPY',
      name: 'Japanese Yen'
    },
    {
      symbol: '₩',
      code: 'KRW',
      name: 'South Korean Won'
    },
    {
      symbol: '₭',
      code: 'LAK',
      name: 'Lao Kip'
    },
    {
      symbol: '₨',
      code: 'LKR',
      name: 'Sri Lankan Rupee'
    },
    {
      symbol: 'ден',
      code: 'MKD',
      name: 'Macedonian Denar'
    },
    {
      symbol: 'RM',
      code: 'MYR',
      name: 'Malaysian Ringgit'
    },
    {
      symbol: '₮',
      code: 'MNT',
      name: 'Mongolian Tugrik'
    },
    {
      symbol: '₨',
      code: 'NPR',
      name: 'Nepalese Rupee'
    },
    {
      symbol: '₦',
      code: 'NGN',
      name: 'Nigerian Naira'
    },
    {
      symbol: 'kr',
      code: 'NOK',
      name: 'Norwegian Krone'
    },
    {
      symbol: '﷼',
      code: 'OMR',
      name: 'Omani Rial'
    },
    {
      symbol: 'S/',
      code: 'PEN',
      name: 'Peruvian Sol'
    },
    {
      symbol: '₱',
      code: 'PHP',
      name: 'Philippine Peso'
    },
    {
      symbol: 'zł',
      code: 'PLN',
      name: 'Polish Złoty'
    },
    {
      symbol: 'lei',
      code: 'RON',
      name: 'Romanian Leu'
    },
    {
      symbol: '₽',
      code: 'RUB',
      name: 'Russian Ruble'
    },
    {
      symbol: '﷼',
      code: 'SAR',
      name: 'Saudi Riyal'
    },
    {
      symbol: 'Дин.',
      code: 'RSD',
      name: 'Serbian Dinar'
    },
    {
      symbol: '₨',
      code: 'PKR',
      name: 'Pakistani Rupee'
    },
    {
      symbol: '₡',
      code: 'SCR',
      name: 'Seychellois Rupee'
    },
    {
      symbol: 'kr',
      code: 'SEK',
      name: 'Swedish Krona'
    },
    {
      symbol: '₺',
      code: 'TRY',
      name: 'Turkish Lira'
    },
    {
      symbol: '$',
      code: 'USD',
      name: 'United States Dollar'
    },
    {
      symbol: '₴',
      code: 'UAH',
      name: 'Ukrainian Hryvnia'
    },
    {
      symbol: '₫',
      code: 'VND',
      name: 'Vietnamese Dong'
    },
    {
      symbol: 'R',
      code: 'ZAR',
      name: 'South African Rand'
    },
    {
      symbol: 'Z$',
      code: 'ZWL',
      name: 'Zimbabwean Dollar'
    },
    {
      symbol: '€',
      code: 'EUR',
      name: 'Euro'
    },
    {
      symbol: 'د.م.',
      code: 'DH',
      name: 'Moroccan Dirham'
    },
    {
      symbol: 'د.ك',
      code: 'KWD',
      name: 'Kuwaiti Dinar'
    }
  ]

  constructor(private vendor: VendorService, private settingService: SettingsService, private fb: FormBuilder, private countriesService: CountriesService) {
    this.settingsForm = this.fb.group({
      currency: [''],
      countryOptions: [''],
      selectedCountries: [[]],
      countryNumber: [''],
      estimatedDeliveryUnit: [''],
      estimatedDeliveryTime: [''],
      hideOutStockProduct: [false],
      shippingOption: ['show'],
      useVariantImageAsMain: [false],
      enableGoogleMaps: [false],
      showCountry: [true],
      showInstagram: [false],
      showFacebook: [false],
      showPhoneNumber: [false],
      // freeShipping: [false],
      meta_pixel_id: [''],
      meta_client_token: [''],
      facebook_displayName: [''],
      showArea: true,
      allowUpload: [false],
      // ✅ Email on Order toggle
      enableOrderEmail: [false],
      enableOrderBooking: [false],

      // ✅ Email template fields
      emailTemplate: [
        `Hello,

        We’re happy to let you know that your order placed on {{orderDate}} has been received and is being processed.

        Order Details:  
        - Status: {{orderStatus}}  
        - Total: {{totalAmount}}

        Your downloads:  
        {{downloadLinks}}

        If you need anything, just reach out to our support team.

        Best regards,  
        {{emailSignature}}`
      ],
      emailSubject: [`We've received your order #{{orderId}} – Thank you from {{appName}}!`],
      emailSignature: [`The {{appName}} Team`],
    })
  }

  ngOnInit(): void {
    this.countries = this.countriesService.getCountries()
    this.loadSettings()
  }

  // Load settings from service
  private loadSettings(): void {
    this.settingService.getSettings().subscribe((settings: Settings) => {
      const effectiveSettings = settings || {}
      // Update form
      this.settingsForm.patchValue({
        currency: effectiveSettings.currency || 'AED',
        countryOptions: effectiveSettings.countryOptions || 'single',
        estimatedDeliveryTime: effectiveSettings.estimatedDeliveryTime || '',
        estimatedDeliveryUnit: effectiveSettings.estimatedDeliveryUnit || '',
        hideOutStockProduct: effectiveSettings.hideOutStockProduct || '',
        shippingOption: effectiveSettings.shippingOption || '',
        useVariantImageAsMain: effectiveSettings.useVariantImageAsMain || '',
        enableGoogleMaps: effectiveSettings.enableGoogleMaps || '',
        // freeShipping: effectiveSettings.freeShipping || false,
        selectedCountries: effectiveSettings.selectedCountries || '',
        countryNumber: effectiveSettings.countryNumber || '+971',
        meta_pixel_id: effectiveSettings.meta_pixel_id || '628192813688005',
        meta_client_token: effectiveSettings.meta_client_token || 'ed23c6bf6ce9251d71e3f383d2068614',
        facebook_displayName: effectiveSettings.facebook_displayName || 'Stacks Demo',
        showArea: effectiveSettings.showArea || true,
        showInstagram: effectiveSettings.showInstagram || false,
        showFacebook: effectiveSettings.showFacebook || false,
        showPhoneNumber: effectiveSettings.showPhoneNumber || false,
        // ✅ Email on Order fields
        enableOrderEmail: effectiveSettings.enableOrderEmail || false,
        enableOrderBooking: effectiveSettings.enableOrderBooking || false,

        emailTemplate:
          effectiveSettings.emailTemplate ||
          `Hello,

          We’re happy to let you know that your order placed on {{orderDate}} has been received and is being processed.

          Order Details:  
          - Status: {{orderStatus}}  
          - Total: {{totalAmount}}

          Your downloads:  
          {{downloadLinks}}

          If you need anything, just reach out to our support team.

          Best regards,  
          {{emailSignature}}`,
        emailSubject: effectiveSettings.emailSubject || `We've received your order #{{orderId}} – Thank you from {{appName}}!`,
        emailSignature: effectiveSettings.emailSignature || `The {{appName}} Team`
      })
      if (effectiveSettings?.showCountry !== undefined) {
        this.settingsForm.patchValue({
          showCountry: effectiveSettings.showCountry || ''
        })
        // Load schedule settings
        if (effectiveSettings?.enableOrderBooking) {
          // this.scheduleService.getScheduleSettings().subscribe();
          this.settingsForm.patchValue({
            enableOrderBooking: effectiveSettings.enableOrderBooking || ''
          })
        }
        if (effectiveSettings?.allowUpload !== undefined) {
          this.settingsForm.patchValue({
            allowUpload: effectiveSettings.allowUpload
          })
        }
      }

      this.settings = effectiveSettings
    })
  }
  /**
   *  Triggered whenever the child <app-schedule-settings> component
   * emits a new schedule via (scheduleChange).
   *
   * This method receives the latest orderBooking array
   * from the child component and stores it locally in this.scheduleData.
   */
  onScheduleChange(schedule: any[]): void {
    this.scheduleData = schedule
  }

  saveSettings(): void {
    this.settingsProgress = true
    const formValue = this.settingsForm.value

    this.settings = {
      ...this.settings,
      currency: formValue.currency || '',
      countryOptions: formValue.countryOptions || '',
      estimatedDeliveryTime: formValue.estimatedDeliveryTime || '',
      estimatedDeliveryUnit: formValue.estimatedDeliveryUnit || '',
      hideOutStockProduct: formValue.hideOutStockProduct || '',
      useVariantImageAsMain: formValue.useVariantImageAsMain || '',
      enableGoogleMaps: formValue.enableGoogleMaps ? formValue.enableGoogleMaps : false,
      showCountry: formValue.showCountry,
      enableOrderBooking: formValue.enableOrderBooking,

      // freeShipping: formValue.freeShipping || false,
      selectedCountries: formValue.selectedCountries,
      countryNumber: formValue.countryNumber,
      meta_pixel_id: formValue.meta_pixel_id,
      meta_client_token: formValue.meta_client_token,
      facebook_displayName: formValue.facebook_displayName,
      allowUpload: formValue.allowUpload,
      showArea: formValue.showArea,
      showInstagram: formValue.showInstagram,
      showFacebook: formValue.showFacebook,
      showPhoneNumber: formValue.showPhoneNumber,
      // ✅ Email on Order fields
      enableOrderEmail: formValue.enableOrderEmail || false,
      emailTemplate: formValue.emailTemplate || '',
      emailSubject: formValue.emailSubject || '',
      emailSignature: formValue.emailSignature || '',
      shippingOption: formValue.shippingOption || 'show'
    }
    // include schedule data if order booking is enabled
    if (formValue.enableOrderBooking && this.scheduleData?.length) {
      this.settings.orderBooking = this.scheduleData
    }

    this.settingService.submitSettings(this.settings).subscribe((result) => {
      const emailForm = {
        enableOrderEmail: formValue.enableOrderEmail || false,
        emailTemplate: formValue.emailTemplate || '',
        emailSubject: formValue.emailSubject || '',
        emailSignature: formValue.emailSignature || ''
      }

      const metaForm = {
        meta_pixel_id: formValue.meta_pixel_id || '628192813688005',
        meta_client_token: formValue.meta_client_token || 'ed23c6bf6ce9251d71e3f383d2068614',
        facebook_displayName: formValue.facebook_displayName || 'Stacks Demo'
      }
      this.settingService.saveMetaData(metaForm).subscribe(() => {
        this.settingService.saveEmailTemplate(emailForm).subscribe(() => {
          if (this.vendor.isMultiVendor) this.vendor.syncSuperVendorSettingsToVendors()
          this.settingsProgress = false
          this.saveState = false
        })
      })
    })
  }

  // Format country number
  startWithPlus(event: Event): void {
    const input = (event.target as HTMLInputElement).value
    const numericInput = input.replace(/\D/g, '')
    this.settingsForm.get('countryNumber')?.setValue(input.startsWith('+') ? `+${numericInput}` : `+${numericInput}`)
  }

  // Activate save state
  activateSave(): void {
    this.saveState = true
  }
}
